// extracted by mini-css-extract-plugin
export default {"ForgotPasswordFormContainer":"ForgotPasswordForm_ForgotPasswordFormContainer__XBTjS","Form":"ForgotPasswordForm_Form__A5oDp","SendButton":"ForgotPasswordForm_SendButton__Y7GRn"};